/**
 * `shell/ModuleSwitcher.tsx` — the top-nav module-switcher dropdown.
 *
 * Extracted from `AppShell.tsx` (behaviour-preserving). Renders the
 * Roster ▾ trigger and the `MODULES` registry as a Radix dropdown.
 * Since #2048 the top bar shows it only when `shouldShowModuleSwitcher`.
 */
import { ChevronDown, Layers } from "lucide-react";
import { Link } from "react-router-dom";

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui";
import { MODULES } from "./navLinks";

export function ModuleSwitcher() {
  // Top-nav module switcher (Roster ▾ → Tasks / Insights / Forecast /
  // Bench / Comply). Per the engineering work order step 7. Stubs all
  // route under `/modules/<name>`; Roster is the working surface (#1959).
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5 text-fg-muted">
          <Layers className="h-3.5 w-3.5" aria-hidden="true" />
          Roster
          <ChevronDown className="h-3 w-3 text-fg-subtle" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuLabel>Tarii modules</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <ModuleMenuItems />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

/**
 * #2048 — the module rows on their own, so the account menu can carry them
 * when the top-bar switcher is hidden (an account with only scheduling
 * teams). `exclude` drops the module the user is already in.
 */
export function ModuleMenuItems({ exclude }: { exclude?: string } = {}) {
  return (
    <>
      {MODULES.filter((m) => m.label !== exclude).map((m) => (
        <DropdownMenuItem key={m.to} asChild>
          <Link to={m.to}>
            <Layers className="h-4 w-4" aria-hidden="true" />
            <span className="flex-1">{m.label}</span>
            {m.status === "active" ? (
              <span className="text-[10px] uppercase tracking-wider text-success">live</span>
            ) : (
              <span className="text-[10px] uppercase tracking-wider text-fg-subtle">soon</span>
            )}
          </Link>
        </DropdownMenuItem>
      ))}
    </>
  );
}
